import React, { useState } from "react";
import { Container, Row, Tab, Tabs } from "react-bootstrap";
import Enter from "../enter/enter";
import Display from "../display/display";
const Hodoradmin = ({ userData }) => {
  const [key, setKey] = useState("enter");
  const [Datee, setDate] = useState("");
  const [StatusAttende, setStatusAttende] = useState("");
  const [time, settime] = useState("");
  const [Day, setDay] = useState("");
  const [Note, setNote] = useState("");
  const [empname, setempname] = useState("");
  const [AttendenceId, setAttendenceId] = useState("");
  const [isEdit, setIsEdit] = useState(false);
    const [Eye, setEye] = useState(false);

  const [EmployeesId, setEmployeesId] = useState(null);
  const [CreatedbyUserId, setCreatedbyUserId] = useState(userData.id);
  
  return (
    <div className="main">
      <Container>
        <h4 className="text-center">إدارة حضور وانصراف </h4>
        <Row>
          <div className="col-md-12">
            <Tabs
              id="controlled-tab-example"
              activeKey={key}
              onSelect={(k) => setKey(k)}
              className="mb-3">
              <Tab eventKey="enter" title="بيانات حضور وانصراف ">
                <Enter
                  userData={userData}
                  key="attendance-enter"
                  setKey={setKey}
                  Datee={Datee}
                  setDate={setDate}
                  StatusAttende={StatusAttende}
                  setStatusAttende={setStatusAttende}
                  time={time}
                  settime={settime}
                  Day={Day}
                  setDay={setDay}
                  empname={empname}
                  setempname={setempname}
                  isEdit={isEdit}
                  setIsEdit={setIsEdit}
                  AttendenceId={AttendenceId}
                  setAttendenceId={setAttendenceId}
                  EmployeesId={EmployeesId}
                  setEmployeesId={setEmployeesId}
                  setNote={setNote}
                  Note={Note}
                  CreatedbyUserId={CreatedbyUserId}
                  setCreatedbyUserId={setCreatedbyUserId}
                  setEye={setEye}
                  Eye={Eye}
                />
              </Tab>
              {/* <Tab eventKey="money" title="ماليات">
                <Money />
              </Tab> */}
              <Tab eventKey="display" title="عرض">
                <Display
                  userData={userData}
                  key="attendance-display"
                  setKey={setKey}
                  Datee={Datee}
                  setDate={setDate}
                  StatusAttende={StatusAttende}
                  setStatusAttende={setStatusAttende}
                  time={time}
                  settime={settime}
                  Day={Day}
                  setDay={setDay}
                  empname={empname}
                  setempname={setempname}
                  isEdit={isEdit}
                  setIsEdit={setIsEdit}
                  AttendenceId={AttendenceId}
                  setAttendenceId={setAttendenceId}
                  EmployeesId={EmployeesId}
                  setEmployeesId={setEmployeesId}
                  setNote={setNote}
                  Note={Note}
                  CreatedbyUserId={CreatedbyUserId}
                  setCreatedbyUserId={setCreatedbyUserId}
                  setEye={setEye}
                  Eye={Eye}
                />
              </Tab>
            </Tabs>
          </div>
        </Row>
      </Container>
    </div>
  );
};

export default Hodoradmin;
